import React, { useEffect, useState } from "react";
import { Container, Label, Input, Button, UncontrolledCollapse, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ReactDragListView from 'react-drag-listview/lib/index.js';
import CustomCollapse from "./CustomCollapse";

function CustomDraggable({ data, setData, children, permission = false }) {
  const [dataState, setDataState] = useState([]);
  useEffect(() => {
    setDataState(data);
  }, [data])
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (permission) {
        const selectedItem = document.querySelectorAll(".accordion-item")[fromIndex];
        if (selectedItem.querySelector(".collapse.show")) {
          return;
        }
        const list = [...dataState];
        const item = list.splice(fromIndex, 1)[0];
        list.splice(toIndex, 0, item);
        setDataState(list);
        setData(list);  
      }
    },
    nodeSelector: 'li',
    handleSelector: 'h2',
    lineClassName: (permission ? "draggable-border" : "border-0") 
  }

  return (
    <React.Fragment >
      <div className='accordion accordion-icon-none'>
        <ReactDragListView {...dragProps}>
          {(data || []).map((item, idx) => {
            return (
              <React.Fragment key={idx}>
                {React.cloneElement(children, { idx: idx, name: item.name, ...item })}
              </React.Fragment>
            )
          })}
        </ReactDragListView>
      </div>
    </React.Fragment >
  )
}

export default CustomDraggable;